import { VueConstructor } from "vue/types/umd";

export class FormatterGlobalMethod {
  public date(value?: string | Date, options?: {}) {
    if (!value) {
      return "";
    }
    if (!(value instanceof Date)) {
      const tmpValue = new Date(value);

      if (isNaN(tmpValue.getTime())) {
        return value;
      }

      value = tmpValue;
    }

    return Intl.DateTimeFormat("ja-JP", options).format(value);
  }

  public datetime(value?: string | Date, options?: {}) {
    if (!value) {
      return "";
    }

    const defaults = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    };
    if (options) {
      Object.assign(defaults, options);
    }

    return this.date(value, defaults);
  }

  public dateHyphened(value?: string | Date) {
    if (!value) {
      return "";
    }
    if (!(value instanceof Date)) {
      value = new Date(value);
    }
    return (
      value.getFullYear() +
      "-" +
      ("00" + (value.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + value.getDate()).slice(-2)
    );
  }

  public number(value?: string | number) {
    if (value !== 0 && !value) return "";
    return Intl.NumberFormat().format(+value);
  }
}
export default {
  install(Vue: VueConstructor) {
    Vue.prototype.$formatter = new FormatterGlobalMethod();
  }
};
